import { PdfSettings } from '../types/app';
import { JobFilters, JobScheduleRequest, JobScheduleRequestTouched } from '../types/jobs';
import { getMonthRange } from '../utils/dates';

export const JOBS_FILTERS_DEFAULTS: JobFilters = {
  startDate: getMonthRange().start,
  endDate: getMonthRange().end,
  jobStatus: [10, 11, 20, 30],
  user: undefined,
  jobType: undefined,
  tenant: undefined,
  paginate: true,
};

export const PDF_SETTINGS_DEFAULTS: PdfSettings = {
  title: 'Constancia de servicio',
  showClientData: true,
  showPlace: true,
  showTenantLogo: true,
  showTimeline: true,
  showVehicleData: true,
  allowPDFExport: true,
};

export const JOBS_STATUS_CODES: { [key: string]: number } = {
  open: 10,
  check_in: 11,
  in_progress: 20,
  issue: 30,
  closed: 40,
  closed_with_issue: 41,
  closed_with_failed_visit: 42,
  cancelled: 50,
};

export const JOB_SCHEDULE_DEFAULT: JobScheduleRequest = {
  userId: '',
  scheduleDate: '',
};

export const JOB_SCHEDULE_TOUCHED_DEFAULT: JobScheduleRequestTouched = {
  userTouched: false,
  scheduleDateTouched: false,
};
